import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { Subscription, forkJoin } from 'rxjs';

import { ExcelService } from './../../../../services/infrastructure/excel.service';
import { GrowerDealerAuditService } from './../../../../services/seed/reports/grower-dealer-audit.service';
import { GrowerOrderService } from './../../../../services/seed/growerOrder.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';

import { MasterConstants } from './../../../../common/constants/master-constants';
import { DashboardFilter } from '../../../../models/DashboardFilter';
import { CommonService } from '../../../../services/common/common.service';
import { UserReportFilterSliderService } from '../../../../common/components/user-report-filter/user-report-filter-slider.service';
import { ReportType } from '../../../../models/report-type.model';
import { UserFilterColumnDisplayed } from '../../../../models/user-filter-columndisplayed.model';
import { ColumnDescription, UserReportFilter } from '../../../../models/user-report-filter.model';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { UserReportFilterService } from '../../../../services/seed/reports/user-report-filter.service';

const _ = require('lodash');

@Component({
  selector: 'app-grower-order-audit',
  templateUrl: './grower-order-audit.component.html',
  styleUrls: ['./grower-order-audit.component.scss']
})
export class GrowerOrderAuditComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('productTable', { read: MatSort }) productSort: MatSort;
  @ViewChild('productPaginator', { read: MatPaginator }) productPaginator: MatPaginator;

  private subscription = new Array<Subscription>();
  private readonly originalDisplayedColumns: any[] = [
    { headertxt: 'Product', columnfield: 'itemDescription', className: 'mat-header-cell productNameBlock text-center', tdClassName: 'mat-cell orderNoText text-center' },
    { headertxt: 'Grower Name', columnfield: 'growerName', className: 'mat-header-cell growerNameCol text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'GMK', columnfield: 'growerGMK', className: 'mat-header-cell accNoCol text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'GLN', columnfield: 'growerGLN', className: 'mat-header-cell accNoCol text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'Audit Date', columnfield: 'auditDate', className: 'mat-header-cell auditTimeBlock text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'Audit Time', columnfield: 'auditTime', className: 'mat-header-cell auditTimeBlock text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'Order Number', columnfield: 'orderNumber', className: 'mat-header-cell accNoCol text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'Account Number', columnfield: 'accountNumber', className: 'mat-header-cell accNoCol text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'Account City', columnfield: 'city', className: 'mat-header-cell accNoCol text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'Explanation', columnfield: 'explanation', className: 'mat-header-cell explanationCol text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'Action', columnfield: 'action', className: 'mat-header-cell actionCol text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'Quantity', columnfield: 'quantity', className: 'mat-header-cell changeQtyCol text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'Change Qty', columnfield: 'changeQty', className: 'mat-header-cell changeQtyCol text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'Modified By', columnfield: 'updatedBy', className: 'mat-header-cell product-line text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'Customer PO', columnfield: 'customerPO', className: 'mat-header-cell custPOCol text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'Seller', columnfield: 'seller', className: 'mat-header-cell sellerCol text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'Is Hybrid Variety Package Size', columnfield: 'isHybridVarietyPackageSize', className: 'mat-header-cell growerNameCol text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: 'Is Reservation Conversion', columnfield: 'isReservationConversion', className: 'mat-header-cell growerNameCol text-center', tdClassName: 'mat-cell text-center' }];
  public currentFilter = new UserReportFilter();

  displayedColumns: string[] = this.originalDisplayedColumns.map(x => x.columnfield);
  //Common
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;

  // Account Dropdown
  ddlAccounts: any;
  accountsLoading = false;
  accountNameCityState: any;
  isAccountSelected = false;

  // Grower Dropdown
  growerList: any[] = [];
  searchCount = 0;
  growerLoading = false;
  growerName: any;

  exportdisabled = true;

  // Filter
  accountId: number;
  selectedValue: string;
  isTextBoxEmpty = true;
  productFilters: any;
  filterValueList = new Array();
  previousSelectedValue: string;
  searchValue = '';
  partialSearchValue = '';
  // productMasterList: any = [];
  marketingMasterList: any = [];
  seedsizeMasterList: any = [];
  packagesizeMasterList: any = [];
  technologyMasterList: any = [];
  treatmentMasterList: any = [];
  maturityMasterList: any = [];
  productLineMasterList: any = [];
  orderNoList: any = [];
  fromDateFilter: any;
  toDateFilter: any;
  isEvolveAccountRestriction = false;
  showHybridVarietyPackageSize = false;
  showReservationConversion = false;
  evolveUserId = '';

  filter = <GrowerOrderAuditLogFilter>{};
  public growerAuditDataSource: MatTableDataSource<any>;
  public growerAuditList: any = [];

  comparisonType: any[] = [{ value: '<' }, { value: '>' }, { value: '=' }, { value: '>=' }, { value: '<=' }, { value: '<>' }];

  searchTypeList: string[] = ['Order Number',
    'Change Quantity',
    'Product Name',
    'Marketing Brand',
    'Seed Size',
    'Package Size',
    'Technology',
    'Item Number',
    'Treatment',
    'Maturity',
    'Product Line',
    'Duration',
    'Account No',
    'Grower Name',
    'City'];

  constructor(private growerDealerAuditService: GrowerDealerAuditService,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private excelService: ExcelService,
    public datePipe: DatePipe,
    private toastrService: ToastrService,
    public commonService: CommonService,
    private growerOrderService: GrowerOrderService,
    private userReportFilterSliderService: UserReportFilterSliderService,
    private userReportFilterService: UserReportFilterService) {
  }

  setDS(source: any[]) {
    this.growerAuditDataSource = new MatTableDataSource(source);
    this.growerAuditDataSource.paginator = this.productPaginator;
    this.growerAuditDataSource.sort = this.productSort;
  }

  private get visibleColumns() {
    return this.originalDisplayedColumns.filter(
      x => (x.columnfield !== 'isHybridVarietyPackageSize' || this.showHybridVarietyPackageSize)
        && (x.columnfield !== 'isReservationConversion' || this.showReservationConversion)
    );
  }

  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.getAccountListAndHybridVisibility();
    this.loadMasterData();
    this.resetAuditFilter();
    this.selectedValue = this.searchTypeList[0];

    this.setDS([]);
    this.getEvolveAccess();

    this.subscription.push(
      this.userReportFilterSliderService.selectedUserFilter.subscribe(filter => {
        if (filter && filter.reportFilter) {
          this.clearAllFilter();
          this.currentFilter = filter;
          const filters: UserFilterColumnDisplayed = JSON.parse(filter.reportFilter);
          this.productFilters = filters.filterOption;

          let filterHeader = []
          filters.displayedColumns.forEach(d => {
            let displayColumn = this.originalDisplayedColumns.filter(x => x.columnfield == d.columnfield);
            if (displayColumn && displayColumn[0]) {
              //fix column at first position
              if (displayColumn[0].columnfield == 'itemDescription') {
                filterHeader.unshift(displayColumn[0].columnfield);
              }
              else if (displayColumn[0].columnfield == 'isHybridVarietyPackageSize') {
                // only add if eligible; ineligible users: skip silently
                if (this.showHybridVarietyPackageSize) {
                  filterHeader.push(displayColumn[0].columnfield);
                }
              }
              else if (displayColumn[0].columnfield == 'isReservationConversion') {
                // only add if eligible; ineligible users: skip silently
                if (this.showReservationConversion) {
                  filterHeader.push(displayColumn[0].columnfield);
                }
              }
              else {
                filterHeader.push(displayColumn[0].columnfield);
              }
            }
          });

          this.displayedColumns = filterHeader;

          this.getGrowerOrderAuditLog();
        }
        else {
          if (filter && filter.filterDescription === this.currentFilter.filterDescription || !filter)
            this.currentFilter = new UserReportFilter();
        }
      }));
  }

  ngOnDestroy() {
    this.userReportFilterSliderService.resetFilter();

    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  getColum(columnfield) {
    return this.originalDisplayedColumns.filter(x => x.columnfield == columnfield)[0];
  }

  getEvolveAccess() {
    const validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    const sessionData = validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
    this.filter.evolveAccountRestriction = sessionData.evolveAccountRestriction;
    this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;
    this.filter.userId = sessionData.userId;
    this.evolveUserId = sessionData.userId;
    this.setFilter();
  }

  setFilter() {
    if (this.isEvolveAccountRestriction) {
      this.searchTypeList = ['Order Number',
        'Change Quantity',
        'Product Name',
        'Marketing Brand',
        'Seed Size',
        'Package Size',
        'Technology',
        'Treatment',
        'Item Number',
        'Maturity',
        'Product Line',
        'Duration',
        'Account',
        'Grower',
        'City'];
    }
    else {
      this.searchTypeList = ['Order Number',
        'Change Quantity',
        'Product Name',
        'Marketing Brand',
        'Seed Size',
        'Package Size',
        'Technology',
        'Treatment',
        'Item Number',
        'Maturity',
        'Product Line',
        'Duration',
        'Account No',
        'Account Name',
        'Grower Name',
        'City'];
    }

    if (this.showHybridVarietyPackageSize) {
      if (!this.displayedColumns.includes('isHybridVarietyPackageSize')) {
        this.displayedColumns.push('isHybridVarietyPackageSize');
      }
    } else {
      this.displayedColumns = this.displayedColumns.filter(x => x !== 'isHybridVarietyPackageSize');
    }

    if (this.showReservationConversion) {
      if (!this.displayedColumns.includes('isReservationConversion')) {
        this.displayedColumns.push('isReservationConversion');
      }
    } else {
      this.displayedColumns = this.displayedColumns.filter(x => x !== 'isReservationConversion');
    }
  }

  getAccountListAndHybridVisibility() {
    this.accountsLoading = true;
    this.subscription.push(
      forkJoin({
        accounts: this.growerDealerAuditService.getGrowerAuditAccountList(),
        visibility: this.growerDealerAuditService.getShowHybridVarietyPackageSize()
      }).subscribe({
        next: ({ accounts, visibility }) => {
          if (accounts) {
            this.ddlAccounts = accounts;
          }
          this.showHybridVarietyPackageSize = !!(visibility && visibility.showHybridVarietyPackageSize);
          this.showReservationConversion = !!(visibility && visibility.showReservationConversion);
          this.accountsLoading = false;
          this.setFilter();
        },
        error: (error) => {
          LolLoggerService.error(error);
          this.accountsLoading = false;
        }
      })
    );
  }

  // Account dropdown change event
  accountChange() {
    if (this.productFilters.Account) {
      this.getGrowerListByAccount(this.productFilters.Account);
    }
  }

  validateAccountId($event) {
    if ($event
      && $event.currentTarget
      && $event.currentTarget.value) {
      this.getGrowerListByAccount($event.currentTarget.value);
      this.filter.account = $event.currentTarget.value;
    }
    else {
      this.isAccountSelected = false;
      this.filter.account = '';
      this.exportdisabled = true;
      this.growerList = [];
      this.searchCount = +0;
      this.setDS([]);
      this.clearAllFilter();
    }
  }

  // Grower Change
  onChangeGDDL(event) {
    if (event) {
    }
    else {
      this.exportdisabled = true;
      this.setDS([]);
      this.clearAllFilter();
    }
  }

  // Account dropdown clear event
  accountClear($event) {
    this.accountChange();
  }

  // Enable Disable Search
  enableDisableSearch() {
    if (this.validateFilter(this.productFilters)) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // Validate Brand Search
  validateBrandSearch() {
    // To Validate Brand
    if (this.productFilters.Brand !== null
      && this.productFilters.Brand !== ''
      && this.productFilters.Brand.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // to validate filter
  validateFilter(productFilter) {
    let isValid = false;

    // To Validate Brand
    if (productFilter.Brand !== null && productFilter.Brand !== '' && productFilter.Brand.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate MarketingBrand
    if (productFilter.MarketingBrandList != null && productFilter.MarketingBrandList.length > 0) {
      isValid = true;
    }

    // To Validate SeedSize
    if (productFilter.SeedSizeList != null && productFilter.SeedSizeList.length > 0) {
      isValid = true;
    }

    // To Validate PackageSize
    if (productFilter.PackageSizeList != null && productFilter.PackageSizeList.length > 0) {
      isValid = true;
    }

    // To Validate Technology
    if (productFilter.Technology != null && productFilter.Technology.length > 0) {
      isValid = true;
    }

    // To Validate Treatment
    if (productFilter.TreatmentList != null && productFilter.TreatmentList.length > 0) {
      isValid = true;
    }

    // To Validate Maturity Min & Max
    if (productFilter.MaturityMin != null && productFilter.MaturityMax != null) {
      isValid = true;
    }
    if (this.selectedValue == 'Maturity' && (productFilter.MaturityMin != null && productFilter.MaturityMax == null)
      &&
      (productFilter.MaturityMin != null && productFilter.MaturityMax == null)) {
      isValid = false;
    }

    // To Validate ProductLine
    if (productFilter.ProductLineList != null && productFilter.ProductLineList.length > 0) {
      isValid = true;
    }
    if (productFilter.Brand == null
      && (productFilter.MarketingBrandList == null || productFilter.MarketingBrandList.length <= 0)
      && (productFilter.SeedSizeList == null || productFilter.SeedSizeList.length <= 0)
      && (productFilter.PackageSizeList == null || productFilter.PackageSizeList.length <= 0)
      && (productFilter.Technology == null)
      && (productFilter.TreatmentList == null || productFilter.TreatmentList.length <= 0)
      && (productFilter.ProductLineList == null || productFilter.ProductLineList.length <= 0)
      && (productFilter.MaturityMin == null)
      && (productFilter.MaturityMax == null)
    ) {
      isValid = false;
    }
    return isValid;
  }

  validateInputText() {
    const accountRegx = RegExp('^[0-9, ]+$');
    const changeQtyRegx = RegExp('^[0-9]+$');

    return ((this.productFilters.AccountNo ? accountRegx.test(this.productFilters.AccountNo) : true) &&
      (this.productFilters.ChangeQty ? changeQtyRegx.test(this.productFilters.ChangeQty) : true));
  }

  // Keep Filter Value
  keepFilter() {
    if (this.filterValueList) {
      // Create filterValueList from Product Filters
      this.filterValueList = [];

      if (this.productFilters) {
        if (!this.validateInputText()) {
          this.toastrService.error('Invalid Input.');
          return false;
        }

        if (this.selectedValue == 'Account') {
          this.accountChange();
        }

        // Set Item No
        if (this.productFilters.ItemNo && this.productFilters.ItemNo.length > 0) {
          var strPL = '';
          this.productFilters.ItemNo.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Item No : ' + strPL.substr(0, strPL.length - 2));
          this.filter.itemNo = strPL;
        } else {
          this.filter.itemNo = null;
        }

        // Set Order No
        if (this.productFilters.OrderNo && this.productFilters.OrderNo != '') {
          this.filterValueList.push('Order No : ' + this.productFilters.OrderNo);
          this.filter.orderNo = this.productFilters.OrderNo;
        }

        // Set change Qty
        if (this.productFilters.ChangeQty && this.productFilters.ChangeQty != '' && this.filter.changeQtyAction) {
          this.filterValueList.push('Change Qty : ' + this.filter.changeQtyAction + ' ' + this.productFilters.ChangeQty);
          this.filter.changeQty = this.productFilters.ChangeQty;
        }

        // Set Account
        if (this.productFilters.AccountNo && this.productFilters.AccountNo != '') {
          this.filterValueList.push('Account No : ' + this.productFilters.AccountNo);
          this.filter.account = this.productFilters.AccountNo;
        }
        else if (this.productFilters.Account && this.productFilters.Account != '') {
          this.filterValueList.push('Account No : ' + this.productFilters.Account);
          this.filter.account = this.productFilters.Account;

          if (this.productFilters.Account == -1) {
            this.filter.account = '-1';
          }
        }
        else {
          this.filter.account = null;
        }

        // Set Account Name
        if (this.productFilters.AccountName && this.productFilters.AccountName != '') {
          this.filterValueList.push('Account Name : ' + this.productFilters.AccountName);
          this.filter.accountName = this.productFilters.AccountName;
        }

        // Set Grower
        if (this.productFilters.GrowerName && this.productFilters.GrowerName != '') {
          this.filterValueList.push('Grower : ' + this.productFilters.GrowerName);
          this.filter.growerName = this.productFilters.GrowerName;
        } else {
          this.filter.growerName = null;
        }

        // Set City
        if (this.productFilters.City && this.productFilters.City != '') {
          this.filterValueList.push('City : ' + this.productFilters.City);
          this.filter.city = this.productFilters.City;
        } else {
          this.filter.city = null;
        }

        if (this.productFilters.Grower && this.productFilters.Grower != '') {
          var strMB = '';
          const obj = this.growerList.filter(y => y.gmk == this.productFilters.Grower);
          if (obj[0]) {
            strMB = strMB + obj[0].businessName + ', ';

            this.filterValueList.push('Grower : ' + strMB.substr(0, strMB.length - 2));
          }
          this.filter.gmk = this.productFilters.Grower;
        }
        else {
          this.filter.gmk = null;
        }

        if (this.productFilters.Brand && this.productFilters.Brand != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.Brand);
          this.filter.productName = this.productFilters.Brand;
        }
        else {
          this.filter.productName = null;
        }

        if (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) {
          var strMB = '';
          this.productFilters.MarketingBrandList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));
          this.filter.marketingBrand = strMB;
        } else {
          this.filter.marketingBrand = null;
        }

        if (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) {
          let strSS = '';
          this.productFilters.SeedSizeList.forEach(x => {
            strSS = strSS + x + ', ';
          });
          this.filterValueList.push('Seed Size : ' + strSS.substr(0, strSS.length - 2));
          this.filter.seedSize = strSS;
        }
        else {
          this.filter.seedSize = null;
        }

        if (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) {
          let strPS = '';
          this.productFilters.PackageSizeList.forEach(x => {
            strPS = strPS + x + ', ';
          });
          this.filterValueList.push('Package Size : ' + strPS.substr(0, strPS.length - 2));
          this.filter.packageSize = strPS;
        }
        else {
          this.filter.packageSize = null;
        }

        if (this.productFilters.Technology && this.productFilters.Technology != '') {
          this.filterValueList.push('Technology : ' + this.productFilters.Technology);
          this.filter.technology = this.productFilters.Technology;
        }
        else {
          this.filter.technology = null;
        }

        if (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) {
          let strTreat = '';
          this.productFilters.TreatmentList.forEach(x => {
            strTreat = strTreat + x + ', ';
          });
          this.filterValueList.push('Treatment : ' + strTreat.substr(0, strTreat.length - 2));
          this.filter.treatment = strTreat;
        }
        else {
          this.filter.treatment = null;
        }

        if (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) {
          var strPL = '';
          this.productFilters.ProductLineList.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));
          this.filter.productLine = strPL;
        } else {
          this.filter.productLine = null;
        }

        if (this.productFilters.MaturityMin != null && this.productFilters.MaturityMax != null) {
          this.filterValueList.push('Maturity : (' + this.productFilters.MaturityMin + ') - (' + this.productFilters.MaturityMax + ')');
          this.filter.maturityMax = this.productFilters.MaturityMax;
          this.filter.maturityMin = this.productFilters.MaturityMin;
        } else {
          this.filter.maturityMax = null;
          this.filter.maturityMin = null;
        }

        if (this.productFilters.FromDate
          && this.productFilters.FromDate != null
          && this.productFilters.ToDate
          && this.productFilters.ToDate != null) {
          this.filterValueList.push('Duration : (' + this.datePipe.transform(this.productFilters.FromDate, 'MM-dd-yyyy') + ') - (' + this.datePipe.transform(this.productFilters.ToDate, 'MM-dd-yyyy') + ')');
          this.filter.fromDate = new Date(this.productFilters.FromDate).toDateString();
          this.filter.toDate = new Date(this.productFilters.ToDate).toDateString();
        }
      }
    }
    this.setAccountTableHeight();
    if (this.productFilters && (this.productFilters.Brand != null && this.productFilters.Brand !== '') ||
      (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) ||
      (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) ||
      (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) ||
      (this.productFilters.Technology && (this.productFilters.Technology != null && this.productFilters.Technology !== '')) ||
      (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) ||
      (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) ||
      (this.productFilters.MaturityMin != null) ||
      (this.productFilters.MaturityMax != null)) {
      this.productFilters = this.getProductFilters(this.productFilters);
    }
    this.enableDisableSearch();

    this.previousSelectedValue = this.selectedValue;
    this.searchValue = '';
    this.partialSearchValue = '';
  }

  // Get Product filter
  getProductFilters(productFilter) {
    this.productFilters.CompanyCode = this.headerCompany;
    this.productFilters.CropYear = this.headerYear;
    this.productFilters.AccountNumber = this.accountId;
    return productFilter;
  }

  // Load master data
  loadMasterData() {
    // get Item Number List
    this.subscription.push(this.commonService.getItemNumbers().subscribe((result: any) => {
      this.orderNoList = result;
    }));

    // MarketingBrand master data
    if (this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST)) {
      this.marketingMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST));
    }

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.seedsizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST)) {
      this.packagesizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST));
    }

    // Technology master data
    if (this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST)) {
      this.technologyMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST));
    }

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST));
    }

    // Maturity master data
    if (this.localStorageService.get(MasterConstants.MATURITY_LIST)) {
      this.maturityMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MATURITY_LIST));
    }

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.productLineMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }
  }

  // Get Grower list
  getGrowerListByAccount(accountNo) {
    if (accountNo) {
      const filterData = {
        cropYear: this.headerYear,
        shipToAccount: accountNo
      };

      const growerFilters = { 'GrowerGLN': '', 'GrowerName': '' };

      this.subscription.push(this.growerOrderService.getGrowerListByFilter(filterData, growerFilters).subscribe(result => {
        this.growerList = result as any[];
        this.searchCount = this.growerList.length;
        this.growerList.forEach(grower => {
          grower.businessName = (grower.businessName == null || grower.businessName == '' ?
            (grower.firstName != null && grower.firstName != '' ? grower.firstName : '') +
            (grower.middleName != null && grower.middleName != '' ? ' ' + grower.middleName : '') +
            (grower.lastName != null && grower.lastName != '' ? ' ' + grower.lastName : '')
            : grower.businessName);
          grower.OrderNumber = grower.growerOrderList[0] ? grower.growerOrderList[0].orderNumber : '';
          grower.GrowerOrderID = grower.growerOrderList[0] ? grower.growerOrderList[0].GrowerOrderID : 0;
          grower.ShipToAccount = grower.growerOrderList[0] ? grower.growerOrderList[0].ShipToAccount : this.accountId;
          grower.OrderStatus = grower.growerOrderList[0] ? grower.growerOrderList[0].OrderStatus : '';
        });
      }, error => LolLoggerService.error(error)));
    }
  }

  // Reset Audit Filter
  resetAuditFilter() {
    this.productFilters = {
      'CompanyCode': this.headerCompany,
      'CropYear': this.headerYear,
      'ItemNo': [],
      'OrderNo': null,
      'ChangeQty': null,
      'AccountNo': null,
      'Account': null,
      'Account Name': null,
      'Grower Name': null,
      'Grower': null,
      'Brand': null,
      'MarketingBrandList': [],
      'SeedSizeList': [],
      'PackageSizeList': [],
      'TechnologyList': [],
      'TreatmentList': [],
      'ProductLineList': [],
      'MaturityMin': null,
      'MaturityMax': null,
      'City': null,
      'Technology': null
    };
  }

  // Clear filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeAuditFilter(filterValue);

      if (this.filterValueList.length < 1) {
        this.growerAuditDataSource = new MatTableDataSource([]);
        this.growerAuditDataSource.paginator = this.productPaginator;
        this.growerAuditDataSource.sort = this.productSort;
      }
      this.setAccountTableHeight();
      this.enableDisableSearch();
    }
  }

  // To remove clear search filter
  removeAuditFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Item No':
        this.productFilters.ItemNo = null;
        this.filter.itemNo = null;
        break;
      case 'Order No':
        this.productFilters.OrderNo = null;
        this.filter.orderNo = null;
        break;
      case 'Change Qty':
        this.productFilters.ChangeQty = null;
        this.filter.changeQty = null;
        this.filter.changeQtyAction = null;
        break;
      case 'Product Name':
        this.productFilters.Brand = null;
        this.filter.productName = null;
        break;
      case 'Marketing Brand':
        this.productFilters.MarketingBrandList = [];
        this.filter.marketingBrand = null;
        break;
      case 'Seed Size':
        this.productFilters.SeedSizeList = [];
        this.filter.seedSize = null;
        break;
      case 'Package Size':
        this.productFilters.PackageSizeList = [];
        this.filter.packageSize = null;
        break;
      case 'Technology':
        this.productFilters.Technology = null;
        this.filter.technology = null;
        break;
      case 'Treatment':
        this.productFilters.TreatmentList = [];
        this.filter.treatment = null;
        break;
      case 'Maturity':
        this.productFilters.MaturityMin = null;
        this.productFilters.MaturityMax = null;
        this.filter.maturityMin = null;
        this.filter.maturityMax = null;
        break;
      case 'Product Line':
        this.productFilters.ProductLineList = [];
        this.filter.productLine = null;
        break;
      case 'Duration':
        this.productFilters.FromDate = null;
        this.productFilters.ToDate = null;
        this.filter.fromDate = null;
        this.filter.toDate = null;
        this.fromDateFilter = '';
        this.toDateFilter = '';
        break;
      case 'EvolveAccountRestriction':
        this.filter.evolveAccountRestriction = null;
        break;
      case 'UserId':
        this.filter.userId = null;
        break;
      case 'Account No':
        this.filter.account = null;
        this.productFilters.Account = null;
        this.productFilters.AccountNo = null;

        this.filter.gmk = null;
        this.filter.growerName = null;
        this.productFilters.Grower = null;
        this.productFilters.GrowerName = null;
        this.growerList = [];

        for (let i = 0; i < this.filterValueList.length; i++) {
          if (this.filterValueList[i].indexOf('Grower') > -1) {
            this.filterValueList.splice(i, 1);
          }
        }

        break;
      case 'Account Name':
        this.filter.accountName = null;
        this.productFilters.AccountName = null;
        break;
      case 'Grower':
        this.filter.gmk = null;
        this.filter.growerName = null;
        this.productFilters.Grower = null;
        this.productFilters.GrowerName = null;
        break;
      case 'City':
        this.filter.city = null;
        this.productFilters.City = null;
        break;
      default:
        break;
    }
  }

  // Clear all filter
  clearAllFilter() {
    this.filterValueList = new Array();
    this.searchValue = '';
    this.isTextBoxEmpty = true;
    this.resetAuditFilter();
    this.validateDateFilter('clearAll', '');
    // To Do clear grid
    this.filter = <GrowerOrderAuditLogFilter>{};
    this.setDS([]);
    this.exportdisabled = true;
    this.currentFilter = new UserReportFilter();
    this.userReportFilterSliderService.resetFilter();
    this.displayedColumns = this.originalDisplayedColumns
      .map(x => x.columnfield)
      .filter(x => (x !== 'isHybridVarietyPackageSize' || this.showHybridVarietyPackageSize)
                && (x !== 'isReservationConversion' || this.showReservationConversion));
    this.setAccountTableHeight();
  }

  //Select filter
  public selectFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.productFilters,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.GrowerOrderAudit, 0, this.visibleColumns, newFilter);
  }

  //Add filter
  public addFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.productFilters,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.GrowerOrderAudit, 1, this.visibleColumns, newFilter);
  }

  //Edit filter
  public editFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.productFilters,
      filterValueList: this.filterValueList,
      displayedColumns: this.displayedColumns.map(x => this.originalDisplayedColumns.find(y => y.columnfield === x))
    };

    this.currentFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.GrowerOrderAudit, 1, this.visibleColumns, this.currentFilter);
  }

  public save(): void {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.productFilters,
      filterValueList: this.filterValueList,
      displayedColumns: this.displayedColumns.map(x => this.originalDisplayedColumns.find(y => y.columnfield === x))
    };

    this.currentFilter.reportFilter = JSON.stringify(filters);

    if (this.currentFilter.userReportFilterId) {
      this.subscription.push(this.userReportFilterService.updateUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      }));
    }
    else {
      this.subscription.push(this.userReportFilterService.addUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      }));
    }
  }

  //Search the account details on Account dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Grower Search
  growerSearchFn(term: string, item: any) {
    if (term) {
      term = term.toLocaleLowerCase();
    }
    return (item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf(term) > -1)
      || (item.growerGMK == null ? false : item.growerGMK.toString().indexOf(term) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf(term) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf(term) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf(term) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf(term) > -1)
      || (item.primaryPhoneNumber == null ? false : item.primaryPhoneNumber.toLocaleLowerCase().indexOf(term) > -1);
  }

  // Serach the data in list and get the serach items count
  search($event) {
    let list: any;
    list = _.filter(this.growerList, item => item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf($event) > -1
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf($event) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf($event) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf($event) > -1)
      || (item.growerGMK == null ? false : item.growerGMK.toString().indexOf($event) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf($event) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf($event) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf($event) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf($event) > -1)
      || (item.primaryPhoneNumber == null ? false : item.primaryPhoneNumber.toLocaleLowerCase().indexOf($event) > -1));
    this.searchCount = list.length;
  }

  // Get Grower Order Audit log
  getGrowerOrderAuditLog() {
    this.keepFilter();

    // Ineligible users must never send this filter regardless of any prior state
    if (!this.showHybridVarietyPackageSize) {
      this.filter.isHybridVarietyPackageSize = null;
    }

    if (!this.showReservationConversion) {
      this.filter.isReservationConversion = null;
    }

    if (!this.filter.gmk) {
      this.filter.gmk = 0;
    }

    if ((this.filter.account == '-1') && (!this.filter.productName || this.filter.productName == '')
      && (!this.filter.itemNo || this.filter.itemNo != '')) {
      this.toastrService.error('Please specify a Product Name or Item Code before initiating a Search');
      return false;
    }

    // Set change Qty to -1 if change Action not selected
    if (!this.productFilters.ChangeQty || this.productFilters.ChangeQty == null) {
      this.filter.changeQty = -1;
    }

    this.loaderService.setLoaderStatus(true);

    this.subscription.push(this.growerDealerAuditService.getGrowerOrderAuditLog(this.filter).subscribe((result: any) => {
      if (result) {
        this.growerAuditList = [];
        this.growerAuditList = result;

        this.setDS(this.growerAuditList);

        this.exportdisabled = false;
      }
      this.loaderService.setLoaderStatus(false);
    }, (error) => {
      this.loaderService.setLoaderStatus(false);
      this.exportdisabled = true;
      LolLoggerService.error(error);
    }));
  }

  // Export data from grid data
  onExportBtnClick() {
    this.loaderService.setLoaderStatus(true);

    if (this.growerAuditList && this.growerAuditList.length > 0) {
      const headerText = this.displayedColumns.map(x => this.originalDisplayedColumns.find(y => y.columnfield === x).headertxt);
      let excelData = [];

      this.growerAuditList.forEach(x => {
        const exportData = new Map();

        headerText.forEach(y => {
          switch (y) {
            case 'Product': {
              exportData.set(y, x.brand + ' ' + x.marketingBrand + ' ' + x.itemDescription)
              break;
            }
            case 'Grower Name': {
              exportData.set(y, x.growerName)
              break;
            }
            case 'GMK': {
              exportData.set(y, x.growerGMK)
              break;
            }
            case 'GLN': {
              exportData.set(y, x.growerGLN)
              break;
            }
            case 'Audit Date': {
              exportData.set(y, this.datePipe.transform(x.auditTime, 'MM-dd-yyyy'))
              break;
            }
            case 'Audit Time': {
              exportData.set(y, this.datePipe.transform(x.auditTime, 'h:mm:ss a'))
              break;
            }
            case 'Order Number': {
              exportData.set(y, x.orderNumber)
              break;
            }
            case 'Account Number': {
              exportData.set(y, x.accountNumber)
              break;
            }
            case 'Account City': {
              exportData.set(y, x.city)
              break;
            }
            case 'Explanation': {
              exportData.set(y, x.explanation)
              break;
            }
            case 'Action': {
              exportData.set(y, x.action)
              break;
            }
            case 'Quantity': {
              exportData.set(y, parseFloat(this.commonService.getFormatedNumber(x.quantity, false)))
              break;
            }
            case 'Change Qty': {
              exportData.set(y, parseFloat(this.commonService.getFormatedNumber(x.changeQty, false)))
              break;
            }
            case 'Modified By': {
              exportData.set(y, x.updatedBy)
              break;
            }
            case 'Customer PO': {
              exportData.set(y, x.customerPO)
              break;
            }
            case 'Seller': {
              exportData.set(y, x.seller)
              break;
            }
            case 'Is Hybrid Variety Package Size': {
              exportData.set(y, x.isHybridVarietyPackageSize)
              break;
            }
            case 'Is Reservation Conversion': {
              exportData.set(y, x.isReservationConversion)
              break;
            }
            default: {
              break;
            }
          }
        });

        const obj = this.autoConvertMapToObject(exportData);
        excelData.push(
          obj
        );
      });

      setTimeout(x => {
        this.excelService.exportExcel(excelData, 'GrowerOrderAudit');
        this.loaderService.setLoaderStatus(false);
      }, 100);
    }
  }

  private autoConvertMapToObject = (map) => {
    const obj = {};
    for (const item of [...map]) {
      const [
        key,
        value
      ] = item;
      obj[key] = value;
    }
    return obj;
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccountTableHeight();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccountTableHeight();
  }

  // Set Account Table Height
  setAccountTableHeight() {
    setTimeout(function () {
      const tableHeight = window.innerHeight - $('.form-sec').outerHeight() - $('.fulfill-top-sec').outerHeight() - 200;
      $('.tableComponentOuter').css('max-height', tableHeight + 'px');
    }, 100);
  }

  validateDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromDate') {
      fromDate = new Date($event.value);
      if (this.productFilters.ToDate) {
        var toDate = new Date(this.productFilters.ToDate);
        this.fromDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toDate') {
      toDate = new Date($event.value);
      this.fromDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.productFilters.FromDate) {
        var fromDate = new Date(this.productFilters.FromDate);
        this.toDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromDateFilter = '';
      this.toDateFilter = '';
    }
  }
}

interface GrowerOrderAuditLogFilter {
  companyCode: string;
  cropYear: number;
  itemNo: string;
  orderNo: string;
  changeQty: number;
  changeQtyAction: string;
  account: string;
  accountName: string;
  growerName: string;
  gmk: number;
  productName: string;
  marketingBrand: string;
  seedSize: string;
  packageSize: string;
  technology: string;
  treatment: string;
  maturityMin: string;
  maturityMax: string;
  productLine: string;
  fromDate: string;
  toDate: string;
  evolveAccountRestriction: boolean;
  userId: string;
  includeChangeQtyZero: boolean;
  city: string;
  isHybridVarietyPackageSize: boolean;
  isReservationConversion: boolean;
}
